/**
 * Si el servidor sirve un `version.json` más nuevo que el del bundle, hay un despliegue nuevo:
 * limpia SW/caches y recarga con query para evitar HTML en caché.
 */
const BUNDLE_STAMP = process.env.VUE_APP_BUILD_STAMP || 'dev'

export async function clearSiteCaches(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((r) => r.unregister()))
    }
  } catch {
    /* noop */
  }
  try {
    const names = await caches.keys()
    await Promise.all(names.map((k) => caches.delete(k)))
  } catch {
    /* noop */
  }
}

/** Invalida SW/caché y recarga con cache-bust (PWA / navegador). */
export async function hardReloadWebApp(): Promise<void> {
  await clearSiteCaches()
  const loc = new URL(window.location.href)
  loc.searchParams.set('v', String(Date.now()))
  window.location.replace(loc.origin + loc.pathname + loc.search + loc.hash)
}

export async function enforceFreshDeploy(): Promise<void> {
  if (!BUNDLE_STAMP || BUNDLE_STAMP === 'dev') {
    return
  }

  const base = (process.env.BASE_URL || '/').replace(/\/?$/, '/')
  const url = `${base}version.json?${Date.now()}`

  let remote: { stamp?: string } | null = null
  try {
    const res = await fetch(url, { cache: 'no-store' })
    if (!res.ok) {
      return
    }
    remote = (await res.json()) as { stamp?: string }
  } catch {
    return
  }

  const serverStamp = remote?.stamp
  if (!serverStamp || serverStamp === BUNDLE_STAMP) {
    sessionStorage.removeItem('deploy_refresh_try')
    return
  }

  const tried = sessionStorage.getItem('deploy_refresh_try')
  if (tried === serverStamp) {
    console.warn(
      '[deploy] Ya se intentó recargar para esta versión; si sigues viendo código viejo, vacía datos del sitio o revisa caché del servidor para index.html.'
    )
    return
  }

  sessionStorage.setItem('deploy_refresh_try', serverStamp)
  await clearSiteCaches()

  const loc = new URL(window.location.href)
  loc.searchParams.set('_deploy', serverStamp)
  window.location.replace(loc.toString())
}
